import { render, staticRenderFns } from "./CtaFooter.vue?vue&type=template&id=2648af91&scoped=true&"
import script from "./CtaFooter.vue?vue&type=script&lang=js&"
export * from "./CtaFooter.vue?vue&type=script&lang=js&"
import style0 from "./CtaFooter.vue?vue&type=style&index=0&id=2648af91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2648af91",
  null
  
)

export default component.exports